// extracted by mini-css-extract-plugin
export default {"content":"AccordionItem_content__Dva29"};